//vue
import Vue from 'vue';
import VueRouter from 'vue-router';
//base
import Login from '../views/Login.vue';
import Home from '../views/Home.vue';
//partner
import Partner from '../views/partner/Index.vue';
import PartnerList from '../views/partner/List.vue';
import PartnerForm from '../views/partner/Form.vue';
//lead
import Lead from '../views/lead/Index.vue';
import LeadList from '../views/lead/List.vue';
import LeadForm from '../views/lead/Form.vue';
//nps
import NPS from '../views/nps/Index.vue';
import NPSList from '../views/nps/List.vue';
import NPSForm from '../views/nps/Form.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: "/home"
  },
  {
    path: '/login',
    component: Login 
  },
  {
    path: '/home',
    component: Home
  },
  {
    path: '/partner',
    component: Partner,
    children: [
      {
        path: "/",
        component: PartnerList
      },
      {
        path: ":id",
        component: PartnerForm
      }
    ]
  },
  {
    path: '/lead',
    component: Lead,
    children: [
      {
        path: "/",
        component: LeadList
      },
      {
        path: ":id",
        component: LeadForm
      }
    ]
  },
  {
    path: '/nps',
    component: NPS,
    children: [
      {
        path: "/",
        component: NPSList
      },
      {
        path: ":id",
        component: NPSForm
      }
    ]
  }
];

const router = new VueRouter({
  routes
});

export default router;
